export default function Skeleton({ height, width, radius = '0px' }) {
  return (
    <>
      <div
        className="skeleton-avatar"
        style={{
          height: height,
          width: width,
          borderRadius: radius,
        }}
      ></div>
    </>
  );
}
